
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2R6UY = parcelRequire("2R6UY");
parcelRequire("cZBYE");
"use strict";
// Default values
var $708a19b676718f6e$var$relay = "polkadot";
var $708a19b676718f6e$var$check = "all";
var $708a19b676718f6e$var$currentTheme = localStorage.getItem("theme") || "light";
var $708a19b676718f6e$var$chartsConfig = $708a19b676718f6e$var$update_chartsConfig($708a19b676718f6e$var$relay, $708a19b676718f6e$var$check, $708a19b676718f6e$var$currentTheme);
function $708a19b676718f6e$var$jsonToPlainStringGeneric(jsonData) {
    const columnNames = Object.keys(jsonData);
    const ids = Object.keys(jsonData[columnNames[0]]);
    let result = "| " + columnNames.join(" | ") + " |\n";
    ids.forEach((id)=>{
        const row = columnNames.map((column)=>{
            const value = jsonData[column][id];
            return value === null ? "N/A" : value;
        }).join(" | ");
        result += "| " + row + " |\n";
    });
    return result;
}
document.addEventListener("DOMContentLoaded", ()=>{
    const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
    document.querySelectorAll('input[name="relaySelection"]').forEach(function(radio) {
        radio.onchange = function() {
            $708a19b676718f6e$var$chartsConfig = $708a19b676718f6e$var$update_chartsConfig($708a19b676718f6e$var$relay = this.value, $708a19b676718f6e$var$check, $708a19b676718f6e$var$currentTheme);
        };
    });
    document.querySelectorAll('input[name="checkSelection"]').forEach(function(radio) {
        radio.onchange = function() {
            $708a19b676718f6e$var$chartsConfig = $708a19b676718f6e$var$update_chartsConfig($708a19b676718f6e$var$relay, $708a19b676718f6e$var$check = this.value, $708a19b676718f6e$var$currentTheme);
        };
    });
    toggleSwitch.addEventListener("change", (e)=>{
        $708a19b676718f6e$var$currentTheme = e.target.checked ? "dark" : "light";
        localStorage.setItem("theme", $708a19b676718f6e$var$currentTheme);
        document.body.classList.toggle("dark-mode", $708a19b676718f6e$var$currentTheme === "dark");
        $708a19b676718f6e$var$update_chartsConfig($708a19b676718f6e$var$relay, $708a19b676718f6e$var$check, $708a19b676718f6e$var$currentTheme);
    });
    if (localStorage.getItem("theme") === "dark") {
        toggleSwitch.checked = true;
        document.body.classList.add("dark-mode");
    }
    $708a19b676718f6e$var$update_chartsConfig($708a19b676718f6e$var$relay, $708a19b676718f6e$var$check, $708a19b676718f6e$var$currentTheme);
});
function $708a19b676718f6e$var$update_chartsConfig(relay, check, currentTheme) {
    $708a19b676718f6e$var$chartsConfig = [
        {
            elementId: "tableMetadata",
            jsonPath: "data/metadata000000000000.jsonl",
            freq: "daily",
            relay: relay,
            check: check,
            build: $2R6UY.populateMetadata
        }
    ];
    $708a19b676718f6e$var$chartsConfig.forEach((config)=>{
        if (!config.elementId.startsWith("table")) {
            const chart = $2R6UY.createEchartElement(config.elementId, currentTheme);
            if (chart) $2R6UY.loadJSONData(config.jsonPath, config.relay, (data)=>{
                config.build(config, data, chart);
            }, chart);
        } else $2R6UY.loadJSONData(config.jsonPath, config.relay, (data)=>{
            config.build(config, data);
        });
    });
}


//# sourceMappingURL=metadata.e1e505e3.js.map
